import React,{ useState,useEffect } from 'react';
import MaterialTable from 'material-table';
import { useSelector} from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { language } from 'config';

export default function Earningreports() {

    const columns =  [
        { title: language.year,field: 'year'},
        { title: language.months, field: 'monthsName' },
        { title: language.Gross_trip_cost, field: 'tripCost',  render: rowData => rowData.tripCost?<span>{parseInt(rowData.tripCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</span>:"" },
        { title: language.trip_cost_driver_share, field: 'rideCost',  render: rowData => rowData.driver_share?<span>{parseInt(rowData.driver_share).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</span>:"" },
        { title: language.convenience_fee, field: 'convenienceFee',  render: rowData => rowData.convenienceFee?<span>{parseInt(rowData.convenienceFee).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</span>:"" },
        
        { title: language.Discounts, field: 'discountAmount', render: rowData => rowData.discountAmount?<span>{parseInt(rowData.discountAmount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</span>:"" },
        { title: language.Profit,  render: rowData => (parseInt(rowData.convenienceFee) - parseInt(rowData.discountAmount)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") , editable:'never'},
        
    ];

  const [data, setData] = useState([]);
  const earningreportsdata = useSelector(state => state.earningreportsdata);

  useEffect(()=>{
        if(earningreportsdata.Earningreportss){
            setData(earningreportsdata.Earningreportss);
        }
  },[earningreportsdata.Earningreportss]);

  return (
    earningreportsdata.loading? <CircularLoading/>:
    <MaterialTable
      title={language.earning_reports}
      columns={columns}
      data={data}
      options={{
        exportButton: true,
      }}
      
    />
  );
}
